// extracted by mini-css-extract-plugin
export var backupIcon = "_nk-1";
export var image = "_nk-0";